import React from "react";
import { Modal } from "antd";

const PortalModal = ({ visible, onHide }) => {
  const buttonStyle = {
    color: "#fff",
    width: "100%",
    marginBottom: "10px",
    display: "flex",
    justifyContent: "center",
    padding: "15px",
    borderRadius: "4px",
    cursor: "pointer",
    textAlign: "center",
    fontWeight: "bold",
    transition: "background-color 0.3s ease, transform 0.3s ease",
  };

  const handleMouseEnter = (e) => {
    e.target.style.transform = "scale(1.05)";
  };

  const handleMouseLeave = (e) => {
    e.target.style.transform = "scale(1)";
  };

  return (
    <Modal
      title={
        <div className="text-center mb-4 font-sans font-bold">
          EKŞİOĞLU PORTAL
        </div>
      }
      closable
      open={visible}
      onCancel={onHide}
      footer={null}
      width={window.innerWidth < 768 ? "90vw" : "30vw"}
    >
      <div className="p-d-flex p-flex-column p-ai-center">
        <div
          style={{
            ...buttonStyle,
            backgroundColor: "#f96332",
          }}
          onClick={() =>
            window.open(
              "https://eksiogluhukukkurumsal.com/dosya-sorgulama",
              "_blank"
            )
          }
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          className="font-sans"
        >
          MÜVEKKİL GİRİŞİ
        </div>
        <div
          style={{
            ...buttonStyle,
            backgroundColor: "#3b82f6",
          }}
          onClick={() =>
            window.open(
              "https://eksiogluhukukkurumsal.com/auth/login",
              "_blank"
            )
          }
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          className="font-sans"
        >
          KURUMSAL GİRİŞ
        </div>
      </div>
    </Modal>
  );
};

export default PortalModal;
